// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
  
  .header-block {
    width: 100%;
    height: 60px;
    border-top: 4px solid #2D6DF6;
    box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.25);
    z-index: 1120;
  } 

  
    .header-block .dropdown {
      width: fit-content;
    }
    .header-block .dropdown .btn-primary, btn-primary:focus {
        background-color: white;
        color: black;
        border: none;
      }
      .header-block .dropdown .dropdown-menu {
        width: 100%;
      }
    
  
  

 
  `, "",{"version":3,"sources":["webpack://./src/components/TopBar/TopBar.css"],"names":[],"mappings":";;EAEE;IACE,WAAW;IACX,YAAY;IACZ,6BAA6B;IAC7B,2CAA2C;IAC3C,aAAa;EACf;;;IAGE;MACE,kBAAkB;IACpB;IACA;QACI,uBAAuB;QACvB,YAAY;QACZ,YAAY;MACd;MACA;QACE,WAAW;MACb","sourcesContent":["\n  \n  .header-block {\n    width: 100%;\n    height: 60px;\n    border-top: 4px solid #2D6DF6;\n    box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.25);\n    z-index: 1120;\n  } \n\n  \n    .header-block .dropdown {\n      width: fit-content;\n    }\n    .header-block .dropdown .btn-primary, btn-primary:focus {\n        background-color: white;\n        color: black;\n        border: none;\n      }\n      .header-block .dropdown .dropdown-menu {\n        width: 100%;\n      }\n    \n  \n  \n\n \n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
